
import React, { useState } from 'react';
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu, Facebook, Instagram } from "lucide-react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Logo from '../images/Logo.svg'; // Updated Logo
import SacModal from './SacModal'; // Import SAC Modal

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();
  const navigate = useNavigate(); // Hook for navigation

  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsScrolled(latest > 50);
  });

  const handleNavigation = (target) => {
      if (target.startsWith('#')) {
          // Check if we are on home page
          if (window.location.pathname === '/') {
              const element = document.getElementById(target.substring(1));
              if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
              }
          } else {
              navigate('/');
              setTimeout(() => {
                  const element = document.getElementById(target.substring(1));
                  if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                  }
              }, 100);
          }
      } else {
          navigate(target);
      }
  };

  return (
    <div className="flex flex-col w-full fixed top-0 z-50">
        <header 
            className={`w-full transition-all duration-300 bg-[#E63312] shadow-md`}
            style={{ height: '164px' }}
        >
            <div className="container mx-auto px-4 h-full grid grid-cols-1 md:grid-cols-3 items-center">
                
                {/* Left: Navigation */}
                <nav className="hidden md:flex items-center justify-start gap-8">
                    <button onClick={() => handleNavigation('/')} className="text-white hover:text-[#FFC300] font-bold uppercase tracking-widest text-sm transition-colors bg-transparent border-none cursor-pointer">
                        Início
                    </button>
                    <button onClick={() => handleNavigation('/cardapio')} className="text-white hover:text-[#FFC300] font-bold uppercase tracking-widest text-sm transition-colors bg-transparent border-none cursor-pointer">
                        Cardápio
                    </button>
                    <SacModal />
					<button onClick={() => handleNavigation('/tabela-nutricional')} className="text-white hover:text-[#FFC300] font-bold uppercase tracking-widest text-sm transition-colors bg-transparent border-none cursor-pointer">
                        Tabela Nutricional
                    </button>
                </nav>

                {/* Center: Logo */}
                <div className="flex justify-center">
                    <button onClick={() => handleNavigation('/')} className="flex items-center group bg-transparent border-none cursor-pointer">
                        <img 
                            src={Logo}
                            alt="O Famoso" 
                            className="h-[100px] w-auto transition-transform transform group-hover:scale-105" 
                        />
                    </button>
                </div>

                {/* Right: Socials & CTA */}
                <div className="hidden md:flex items-center justify-end gap-6">
                    <div className="flex items-center gap-4">
                        <a href="https://www.facebook.com/salgadosofamoso" target="_blank" rel="noreferrer" className="text-white hover:text-[#FFC300] transition-colors">
                            <Facebook className="h-6 w-6" />
                        </a>
                        <a href="https://www.instagram.com/ofamososalgado/" target="_blank" rel="noreferrer" className="text-white hover:text-[#FFC300] transition-colors">
                            <Instagram className="h-6 w-6" />
                        </a>
                    </div>
                    <Button 
                        onClick={() => handleNavigation('#lojas')}
                        className="bg-[#FFC300] hover:bg-white text-[#E63312] hover:text-[#E63312] font-black uppercase tracking-wider rounded-full px-6 py-6 text-sm transition-all shadow-lg hover:shadow-xl"
                    >
                        Peça Agora
                    </Button>
                </div>

                {/* Mobile Menu Trigger */}
                <div className="md:hidden absolute right-4 top-1/2 -translate-y-1/2">
                    <Sheet>
                        <SheetTrigger asChild>
                            <Button variant="ghost" size="icon" className="text-white">
                                <Menu className="h-8 w-8" />
                            </Button>
                        </SheetTrigger>
                        <SheetContent className="bg-[#E63312] border-none text-white w-[300px]">
                            <div className="flex flex-col gap-8 mt-10 items-center text-center">
                                <img 
                                    src={Logo} 
                                    alt="O Famoso" 
                                    className="h-20 w-auto mb-4" 
                                />
                                <button onClick={() => handleNavigation('/')} className="text-xl font-bold uppercase hover:text-[#FFC300] bg-transparent border-none cursor-pointer text-white">Início</button>
                                <button onClick={() => handleNavigation('/cardapio')} className="text-xl font-bold uppercase hover:text-[#FFC300] bg-transparent border-none cursor-pointer text-white">Cardápio</button>
                                <div className="scale-125">
                                    <SacModal />
                                </div>
								<button onClick={() => handleNavigation('/tabela-nutricional')} className="text-xl font-bold uppercase hover:text-[#FFC300] bg-transparent border-none cursor-pointer text-white">
                                    Tabela Nutricional
                                </button>

                                <div className="flex gap-6 my-4">
                                     <a href="#" className="text-white hover:text-[#FFC300]"><Facebook className="h-6 w-6" /></a>
                                     <a href="#" className="text-white hover:text-[#FFC300]"><Instagram className="h-6 w-6" /></a>
                                </div>
                                <Button 
                                    onClick={() => {
                                        handleNavigation('#lojas');
                                        document.querySelector('[data-state="open"]')?.click();
                                    }}
                                    className="bg-[#FFC300] text-[#E63312] hover:bg-white w-full font-bold text-lg h-12 uppercase"
                                >
                                    Peça Agora
                                </Button>
                            </div>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </header>
    </div>
  );
};

export default Header;
